export default __webpack_public_path__ + "static/media/almacen.9a7a5233.png";